// postGenerator.js
import { generateComment } from "./commentGenerator";
import { generateAdContent } from "./adGenerator";

const NAMES = [
  "Skyline42",
  "Nova_Surge",
  "Blaze-It",
  "Echo7Rift",
  "CryptoGeek",
  "WarpZone_99",
  "DreamxVision",
  "Frost-Xtreme",
  "Lunar.99",
  "ShadowSpark",
  "PixelCrafter",
  "Turbo_Track",
  "Neo.Pulse23",
  "Nimbus-Path",
  "CloudHaven8",
  "Gadget-Guy_24",
  "MetaLoomer",
  "Fusion.Time",
  "Glitcher5x",
  "Cyber_Dream",
  "DuneRider",
  "Starship.Zed",
  "PhantomX82",
  "Rustic_Bravo",
  "Mystic04",
  "Shimmer-X",
  "NovaDash",
  "Circuit99",
  "Aether-Bound",
  "Storm.Seeker",
  "BrightXcape",
  "Sky_Glitcher",
  "Silent.Wisp",
  "Lush-Zero",
  "AuroraXer",
  "Stealth-Logic",
  "Trail99",
  "Blitz_Rider",
  "EchoClash",
  "Flicker_Sky",
  "DigitalAlpha",
  "Prism-XR",
  "SonicCrafter",
  "Warped.Lines",
  "Silver-X99",
  "Vortex_Cloud",
  "Stellar-Z",
  "Neo_Shifter",
  "StaticBlaze",
  "FrostTrail",
  "Bright_Void",
  "Timber-X42",
  "Comet.Seeker",
  "Cyber-Q9",
  "MoonForge8",
  "Zodiac.Sky",
  "Shadow_Burst",
  "QuantumX24",
  "Glitch-Pulse",
  "Infinity.79",
  "Skyline_Warp",
  "Prismatic55",
  "GraphiteXy",
  "Electric_Zephyr",
  "MetaForge5",
  "Crystal.Loop",
  "Twilight66",
  "Trail.99",
  "Cipher-X1",
  "NimbusShift",
  "RusticEcho",
  "Dusk-XR",
  "Velvet_99",
  "Cosmic-Line",
  "DreamTrek23",
  "Lumen-Q",
  "Zodiac-55",
  "SkyStreak",
  "Pixel.X99",
  "Circuit.Seeker",
  "Fusion_Road",
  "GlitchZone",
  "Turbo-Z",
  "Neo_Spark",
  "Static_Pulse",
  "Harmony.X3",
  "Chrono-Rift",
  "Nova_Flow",
  "Shimmer.Voice",
  "Sky-Vector",
  "Nimbus_Streak",
  "LunarForgeX",
  "Rustic99",
];

function getUserName(userCount) {
  return NAMES[Math.floor(Math.random() * Math.min(userCount, NAMES.length))];
}

export function generatePost(gameState) {
  const { adFrequency, adPersonalization, userCount } = gameState;

  // Zero-ad case
  if (adFrequency === 0) {
    return {
      id: Date.now(),
      author: "@" + getUserName(userCount),
      content: generateComment(gameState),
      isAd: false,
    };
  }

  // Determine if this should be an ad based on adFrequency
  const isAd = Math.random() * 100 < adFrequency;

  if (isAd) {
    let { company, content } = generateAdContent(adPersonalization);
    return {
      id: Date.now(),
      author: company,
      content: content,
      isAd: true,
      sponsor: company,
    };
  }

  return {
    id: Date.now(),
    author: "@" + getUserName(userCount),
    content: generateComment(gameState),
    isAd: false,
  };
}
